module.exports = __webpack_public_path__ + "src/assets/images/red-warning.b11a1cbfca435252b87a14b984c1aea0.svg";